import React from 'react';

import PointOfViewTeaser from './Teaser';
import PointOfViewDetail from './Detail';

const NodePointOfView = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <PointOfViewTeaser {...props} />;
  }

  return <PointOfViewDetail {...props} />;
};

export default NodePointOfView;
